import { merge } from "lodash-es";
import { sharedTranslations } from "../../shared-translations.js";

export const traveluroSpecificTranslations = {
  "traveluro-home-page": {
    title: "Find great hotels for your next trip!",
    "top-destinations-title": "Top Destinations",
  },
  "html-metadata": {
    "brand-name": "Traveluro",
  },
} as const;

export type ITraveluroSpecificTranslations = typeof traveluroSpecificTranslations;

const traveluroTranslations = merge({}, sharedTranslations, traveluroSpecificTranslations);
export const translations = {
  dictionary: traveluroTranslations,
  language: "EN",
};
